import React from 'react'
import { useSelector } from 'react-redux';
import { IState } from 'shared/store/reducers';
import {
  ListFilterMenuForDate,
  ListFilterMenuForSelect,
  ListFilterMenuForString,
  ListFilterMenuForTag
} from './ListFiltersMenus';
import { FILTER_TYPE } from './types';

type ListFilterMenuContentProps = {
  filter: any;
  onHandleApply: any;
}

const ListFilterMenuContent = ({ filter, onHandleApply }: ListFilterMenuContentProps) => {
  switch (filter.type) {
    case FILTER_TYPE.STRING:
      return (
        <ListFilterMenuForString
          filter={filter}
          value={filter.value}
          onApply={onHandleApply}
          options={filter.options || []}
        ></ListFilterMenuForString>
      );
    case FILTER_TYPE.DATE:
      return (
        <ListFilterMenuForDate
          filter={filter}
          value={filter.value}
          onApply={onHandleApply}
          options={filter.options || []}
        ></ListFilterMenuForDate>
      );
    case FILTER_TYPE.SELECT:
      return (
        <ListFilterMenuForSelect
          filter={filter}
          value={filter.value}
          onApply={onHandleApply}
          options={filter.options || []}
        ></ListFilterMenuForSelect>
      );
    case FILTER_TYPE.TAG:
      return (
        <ListFilterMenuForTag
          filter={filter}
          value={filter.value}
          onApply={onHandleApply}
          options={filter.options || []}
        ></ListFilterMenuForTag>
      );
    default:
      return <div />

  }
}

export default ListFilterMenuContent
